import type { ArrayElement, StudentGroup as StudentGroupType } from '@evidia/shared';
import { STUDENT_GROUP_TEXT } from '@evidia/shared';
import type { RouterOutput } from '../utils/trcp';

type StudentGroupTypePrismaType = NonNullable<
	ArrayElement<ArrayElement<RouterOutput['student']['studentsWithExams']>['studentOnExam']>['group']
>;

interface Props {
	type: StudentGroupType | StudentGroupTypePrismaType;
}

const StudentGroup: React.FC<Props> = ({ type }) => <>{(STUDENT_GROUP_TEXT as any)[type as any]}</>;

export default StudentGroup;
